import React from 'react';
import SearchParams from '../Elements/SearchParams';
import FpaSearchParams from '../Contents/FreelancerInvoicing/FreelancerPayableAssignments/FpaSearchParams';
import FreelancerPayableAssignment from '../Domain/FreelancerPayableAssignmentsItem';
import dateTimeHelper from '../Helpers/datetimeHelper';
import AuthService from './authService.js';

class FreelancerPayableAssignmentsService extends React.Component {
  static GetAssignmentList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    searchItem.StartDate = dateTimeHelper.toYYYYsMMsDD(searchItem.StartDate);
    searchItem.EndDate = dateTimeHelper.toYYYYsMMsDD(searchItem.EndDate);
    searchItem.FreelancerPayableAssignmentsId = FreelancerPayableAssignmentsService.toStringAndClearZero(
      searchItem.FreelancerPayableAssignmentsId
    );
    searchItem.FreelancerInvoiceId = FreelancerPayableAssignmentsService.toStringAndClearZero(
      searchItem.FreelancerInvoiceId
    );

    const searchParams = new SearchParams(searchItem, FpaSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/FreelancerPayableAssignments/GetList/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static toStringAndClearZero(value) {
    value = value.toString();
    return value === '0' ? '' : value;
  }

  static GetAssignmentListByInvoiceId(id) {
    const url = `/api/FreelancerPayableAssignments/GetFreelancerPayableAssignmentsByInvoiceId/${id}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  // static GetAssignmentById(id) {
  //   const url = `/api/FreelancerPayableAssignments/GetById/${id}?clearCache=false`;
  //   return AuthService.getInstance().CallBackendFunction(url);
  // }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new FreelancerPayableAssignment(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static async AttachFreelancerPayableAssignmentsToFreelancerInvoice(
    selectedIds,
    allItemInTheSearchAreSelected,
    searchItem
  ) {
    const assignmentsToAdd = FreelancerPayableAssignmentsService.getSelectedAssignmentsObject(
      selectedIds,
      allItemInTheSearchAreSelected,
      searchItem
    );
    const url = 'api/FreelancerPayableAssignments/AttachFreelancerPayableAssignmentsToFreelancerInvoice';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(assignmentsToAdd));
  }

  static getSelectedAssignmentsObject(selectedIds, allItemInTheSearchAreSelected, searchItem) {
    searchItem.FreelancerPayableAssignmentsId = FreelancerPayableAssignmentsService.toStringAndClearZero(
      searchItem.FreelancerPayableAssignmentsId
    );
    searchItem.FreelancerInvoiceId = FreelancerPayableAssignmentsService.toStringAndClearZero(
      searchItem.FreelancerInvoiceId
    );
    return {
      SelectedIds: selectedIds,
      AllItemInTheSearchAreSelected: allItemInTheSearchAreSelected,
      SearchParams: {
        Command: '',
        OrderBy: '',
        OrderDirection: '',
        PageNumber: 0,
        NumberOfElementsOnAPage: 0,
        SearchItem: searchItem,
      },
    };
  }

  static async DetachFreelancerPayableAssignmentsFromFee(selectedIds, allItemInTheSearchAreSelected, searchItem) {
    const assignmentsToRemove = FreelancerPayableAssignmentsService.getSelectedAssignmentsObject(
      selectedIds,
      allItemInTheSearchAreSelected,
      searchItem
    );
    const url = 'api/FreelancerPayableAssignments/DetachFreelancerPayableAssignmentsFromFee/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(assignmentsToRemove));
  }

  static async RemovePayableAssignmentFromFreelancerInvoice(id) {
    const url = 'api/FreelancerPayableAssignments/RemoveFreelancerPayableAssignmentFromFreelancerInvoice';
    return AuthService.getInstance().CallBackendFunctionPut(url, id);
  }

  static async LookingForFeeToFreelancerPayableAssignments(selectedIds, allItemInTheSearchAreSelected, searchItem) {
    const selectedAssignments = FreelancerPayableAssignmentsService.getSelectedAssignmentsObject(
      selectedIds,
      allItemInTheSearchAreSelected,
      searchItem
    );
    const url = 'api/FreelancerPayableAssignments/LookingForFee';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(selectedAssignments));
  }

  static async RemoveFreelancerPayableAssignmentsFromInvoice(selectedIds, allItemInTheSearchAreSelected, searchItem) {
    const assignmentsToRemove = FreelancerPayableAssignmentsService.getSelectedAssignmentsObject(
      selectedIds,
      allItemInTheSearchAreSelected,
      searchItem
    );
    const url = 'api/FreelancerPayableAssignments/RemoveFreelancerPayableAssignmentsFromInvoice';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(assignmentsToRemove));
  }

  static async SetFreelancerPayableAssignmentsToUninvoiceable(selectedIds, allItemInTheSearchAreSelected, searchItem) {
    const assignmentsToSet = FreelancerPayableAssignmentsService.getSelectedAssignmentsObject(
      selectedIds,
      allItemInTheSearchAreSelected,
      searchItem
    );
    const url = 'api/FreelancerPayableAssignments/SetFreelancerPayableAssignmentsToUninvoiceable';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(assignmentsToSet));
  }

  static async SetFreelancerPayableAssignmentsToInvoiceable(selectedIds, allItemInTheSearchAreSelected, searchItem) {
    const assignmentsToSet = FreelancerPayableAssignmentsService.getSelectedAssignmentsObject(
      selectedIds,
      allItemInTheSearchAreSelected,
      searchItem
    );
    const url = 'api/FreelancerPayableAssignments/SetFreelancerPayableAssignmentsToInvoiceable';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(assignmentsToSet));
  }

  static ExportAdminExcelAsync(searchItem) {
    const url = `/api/FreelancerPayableAssignments/ExportAdminExcelAsync?searchItem=${JSON.stringify(
      searchItem
    )}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }
}

export default FreelancerPayableAssignmentsService;
